'use strict';

var Sugar = require('sugar-core'),
    getMinOrMax = require('../enumerable/internal/getMinOrMax');

Sugar.Array.defineInstance({

  'min': function(arr, all, map) {
    return getMinOrMax(arr, all, map);
  }

});

module.exports = Sugar.Array.min;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/min.js
// module id = 413
// module chunks = 0